import Overview from '@/rebuild/materials/shared/corporate_governance/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/corporate_governance/MobOverview.vue';
import MobFull from '@rebuild/materials/shared/corporate_governance/MobFull.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/corporate_governance/context';

export function useSelfContext() {
	provideCurrentContext();
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	'mob-overview': withProvider(MobOverview, useSelfContext),
	'mob-full': withProvider(MobFull, useSelfContext)
};
